module.exports = __webpack_public_path__ + "static/img/banner.9bc0658.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-sf/banner.jpg
// module id = PdaJ
// module chunks = 2